module.exports = __webpack_public_path__ + "img/clients-dt.0ff36f9b.png";